import { Modal } from 'bootstrap.native';

/** Class for handling a modal with a session expiration message.
 * Using the attribute [data-session-timeout-in-minutes] containing the timeout in minutes.
 * Using the attribute [data-time-to-session-expiry-prompt-in-minutes] containing the promtped time in minutes.
 * Using the attribute [data-session-expiry-prompt-duration-in-minutes] containing the prompt duration in minutes.
 * Using the attribute [data-session-expiry-prompt-title] containing the prompt title.
 * Using the attribute [data-session-expiry-prompt-timeout-redirect-url] containing the timeout redirect url.
 * Using the attribute [data-session-expiring-popup-title] containing the pop up title.
 * Using the attribute [data-session-expiring-popup-text] containing the popup text.
 * Using the attribute [data-extend-session-button-text] button text to extend session.
 * Using the attribute [data-session-extend-count] count to extend session count times .
 * 
 */
export class TimeoutBox {
    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        this.modalElement = document.querySelector('#session-expiry-dialog');
        this.element = element;
        element.TimeoutBox = this;
        this.modal = this.modalElement.Modal || new Modal(this.modalElement);
        
        this.timeToSessionExpiryPromptInMinutes = element.getAttribute('data-time-to-session-expiry-prompt-in-minutes');
        this.sessionExpiryPromptDurationInMinutes = element.getAttribute('data-session-expiry-prompt-duration-in-minutes');
        this.sessionExpiryPromptTitle = element.getAttribute('data-session-expiry-prompt-title');
        this.sessionExtendCount = element.getAttribute('data-session-extend-count');
        this.promptCountDownStartInMillisecond = this.timeToSessionExpiryPromptInMinutes * 60 * 1000;

        this.minutesToTimeout = parseInt(this.timeToSessionExpiryPromptInMinutes) + parseInt(this.sessionExpiryPromptDurationInMinutes);
        this.expiryDateTime = this.addMinutes(new Date(), this.minutesToTimeout);

        this.sessionExpired;
        this.displayCountdownIntervalId;
        var _this = this;
        this.promptSessionExpiring = setTimeout(function(){_this.sessionExpiring(_this)}, this.promptCountDownStartInMillisecond);

        this.addEventListeners();
    }

    addEventListeners() {
        const extendSessionButton = this.modalElement.querySelector('#extend-session-button');
        if(extendSessionButton) {
            extendSessionButton.addEventListener('click', () => {
                this.extendSession();
                this.expiryDateTime = this.addMinutes(new Date(), this.minutesToTimeout);
                clearTimeout(this.sessionExpired);
                clearInterval(this.displayCountdownIntervalId);
                var _this = this;
                this.promptSessionExpiring = setTimeout(function(){_this.sessionExpiring(_this)}, this.promptCountDownStartInMillisecond);
                this.modal.toggle();
            });
        }
    }

    stringHelpers() {
        return {
            padLeft: function (string, padMask) {
                string = '' + string;
                return (padMask.substr(0, (padMask.length - string.length)) + string);
            }
        }
    }

    displayCountdown() {
        var _this = this;
        var countdown = function () {
            var currentDateTime = new Date();

            if (currentDateTime >= _this.expiryDateTime) {
                _this.handleSessionExpired();
            }

            var timeToSessionExpiry = _this.timeToSessionExpires(currentDateTime);

            var cd = new Date(timeToSessionExpiry),
                minutes = cd.getUTCMinutes(),
                seconds = cd.getUTCSeconds(),                
                cdDisplay = minutes + ':' + _this.stringHelpers().padLeft(seconds, '00');

            document.querySelector('#expiredTime').innerText = cdDisplay;
        };
        countdown();
        this.displayCountdownIntervalId = setInterval(countdown, 1000);
    }

    timeToSessionExpires(dateTime) {
        var difference = this.expiryDateTime.getTime() - dateTime.getTime();        

        return Math.abs(Math.round(difference));
    }

    addMinutes(date, minutes) {
        return new Date(date.getTime() + minutes * 60000);
    }

    sessionExpiring(timeoutBox) {
        if ((this.sessionExtendCount != undefined) && (this.sessionExtendCount > 0))
        {
            // Just extend the session
            this.sessionExtendCount = this.sessionExtendCount - 1;
            console.log('Extending session: '.concat(this.sessionExtendCount));
            this.extendSession();
            this.expiryDateTime = this.addMinutes(new Date(), this.minutesToTimeout);
            clearTimeout(this.promptSessionExpiring);
            var _this = this;
            this.promptSessionExpiring = setTimeout(function () { _this.sessionExpiring(_this) }, this.promptCountDownStartInMillisecond);
        }
        else if (timeoutBox !== undefined) {
            timeoutBox.sessionExpired = setTimeout(timeoutBox.handleSessionExpired, timeoutBox.sessionExpiryPromptDurationInMinutes * 60 * 1000);
            timeoutBox.modal.toggle();
            timeoutBox.displayCountdown();
        }
    }

    handleSessionExpired() {
        clearTimeout(this.sessionExpired);
        clearTimeout(this.promptSessionExpiring);
        clearInterval(this.displayCountdownIntervalId);

        var sessionExpiredRedirectUrl = this.element.getAttribute('data-session-expiry-prompt-timeout-redirect-url');
        this.modal.toggle();

        if (sessionExpiredRedirectUrl === "") {
            sessionExpiredRedirectUrl = "/?logout=true";
        }

        location.href = sessionExpiredRedirectUrl;
    }

    // getting root is enough for renewing authentication
    extendSession(){
        var xhr = new XMLHttpRequest();
        xhr.open("GET", "/", true);
        xhr.send(null);
    }
}